import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center p-5 py-10 space-y-10" }
const _hoisted_2 = { class: "flex flex-col space-y-6 items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex text-brand-light-gray" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-10 h-10 flex bg-brand-light-gray rounded-full" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "m-auto h-5 fill-current text-brand-black my-auto",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" })
    ])
  ])
], -1)
const _hoisted_4 = { class: "flex flex-col w-full items-center space-y-1 px-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Verification Required", -1)
const _hoisted_6 = { class: "text-brand-light-gray text-lg text-center" }

import {onMounted, ref} from 'vue';
import {Observable, ObservableEvent} from "@/services/observable/Observable";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationRequiredSheet',
  props: {
  text: {
    type: String,
    default: 'You must be verified to perform this action.'
  }
},
  setup(__props) {


const loading = ref(true)

const props = __props

onMounted(async () => {
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.text), 1)
      ])
    ])
  ]))
}
}

})